import Vue from "vue";
import { Component } from "vue-property-decorator";
import ListItemStringModel from "../../models/listItemStringModel";
import MailingContractorCarrierEmailDataModel from "../../models/rest/mailing/mailingContractorCarrierEmailDataModel";
import MailingContractorCarrierEmailPlaceDataModel from "../../models/rest/mailing/mailingContractorCarrierEmailPlaceDataModel";
import CountryRestModel from "../../models/rest/register/countryRestModel";


@Component
export default class MailingContractorCarrierDialog extends Vue {
    dateTimeLabel = this.$t("mailing.dateTime");
    formValid = false;

    get isLoading(): boolean {
        return this.$store.direct.state.loading;
    }

    get showDialog(): boolean {
        return this.$store.direct.state.mailing.showMailingContractorCarrierDialog;
    }

    get emailData(): MailingContractorCarrierEmailDataModel {
        return this.$store.direct.state.mailing.mailingContractorCarrierEmailData;
    }

    get mailingVehicleTypes() {
        return this.$store.direct.state.mailing.mailingVehicleTypes;
    }

    get allCountries(): CountryRestModel[] {
        return this.$store.direct.state.contractor.contractorAssets.countries;
    }

    get unitTypeArray(): string[] {
        return this.$store.direct.state.common.unitTypeArray;
    }

    get weightUnitTypeArray(): string[] {
        return this.$store.direct.state.common.weightUnitTypeArray;
    }

    get emailCopyReplyToEmailAddressList(): string[] {
        return this.$store.direct.state.common.dispoEmailAddressList;
    }

    created() {
        this.$store.direct.dispatch.common.loadDispoEmailAddressList();
    }

    cancelClick() {
        this.$store.direct.dispatch.mailing.isNotConfirmedMailingContractorCarrierDialog();
    }

    async sendClick() {
        const form = (this.$refs.form as any);
        if (!form.validate()) return;

        await this.$store.direct.dispatch.mailing.sendMailingContractorCarrierEmail();
        await this.$store.direct.dispatch.mailing.isConfirmedMailingContractorCarrierDialog({ isConfirmed: true });
        this.$store.direct.commit.mailing.setMailingContractorCarrierEmailData({} as MailingContractorCarrierEmailDataModel);
    }
}
